import { render, staticRenderFns } from "./BranchCard.vue?vue&type=template&id=aabf7afa"
import script from "./BranchCard.vue?vue&type=script&lang=ts"
export * from "./BranchCard.vue?vue&type=script&lang=ts"
import style0 from "./BranchCard.vue?vue&type=style&index=0&id=aabf7afa&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports